// API
export const CREATE_CACHE = "/createCache";
export const CREATE_DEFERRED = "/createDeferred";
export const CREATE_EXTERNALLY_MANAGED_CACHE = "/createExternallyManagedCache";
export const CREATE_INTERVAL_CACHE = "/createIntervalCache";
export const CREATE_SINGLE_ENTRY_CACHE = "/createSingleEntryCache";
export const CREATE_STREAMING_CACHE = "/createStreamingCache";
export const IS_PROMISE_LIKE = "/isPromiseLike";
export const RECORD_AND_RECORD_DATA_UTILS = "/Record-and-RecordData-utils";
export const USE_CACHE_MUTATION = "/useCacheMutation";
export const USE_CACHE_STATUS = "/useCacheStatus";
export const USE_IMPERATIVE_CACHE_VALUE = "/useImperativeCacheValue";
export const USE_IMPERATIVE_INTERVAL_CACHE_VALUES =
  "/useImperativeIntervalCacheValues";
export const USE_INTERVAL_CACHE_STATUS = "/useIntervalCacheStatus";
export const USE_STREAMING_CACHE = "/useStreamingValue";

// Guides
export const GUIDE_ABORT_A_REQUEST = "/guide/abort-a-request";
export const GUIDE_DEBUG_LOGGING = "/guide/debugging-slow-requests";
export const GUIDE_FETCH_WITH_STATUS = "/guide/rendering-cache-status";
export const GUIDE_MEMORY_MANAGEMENT = "/guide/memory-management";
export const GUIDE_MUTATING_A_CACHE_VALUE = "/guide/mutating-cache-values";
export const GUIDE_OPTIMIZING_IMMUTABLE_CACHES =
  "/guide/optimizing-immutable-caches";
export const GUIDE_STREAMING_CACHE = "/guide/writing-a-streaming-cache";
